import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ToastController } from '@ionic/angular/standalone';
import { PwaDeviceService } from './pwa-device.service';

const DISMISS_KEY = 'gymfyfit-pwa-install-dismissed';

@Injectable({ providedIn: 'root' })
export class PwaInstallService {
  constructor(
    private readonly toastController: ToastController,
    private readonly pwaDeviceService: PwaDeviceService
  ) {}

  async maybeShowInstallHint(): Promise<void> {
    if (
      Capacitor.isNativePlatform() ||
      !this.pwaDeviceService.isWebAccessAllowed() ||
      this.isStandalone() ||
      this.wasDismissed()
    ) {
      return;
    }

    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isAndroidChrome = /android/i.test(navigator.userAgent) && /chrome/i.test(navigator.userAgent);

    if (isIos) {
      await this.showToast(
        'Para instalar no iPhone: toque em Compartilhar e depois em "Adicionar à Tela de Início".',
        12000
      );
      return;
    }

    if (isAndroidChrome) {
      await this.showToast(
        'Instale o Gymfyfit: menu do navegador → "Adicionar à tela inicial" ou "Instalar app".',
        10000
      );
    }
  }

  private isStandalone(): boolean {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as Navigator & { standalone?: boolean }).standalone === true
    );
  }

  private wasDismissed(): boolean {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  }

  private async showToast(message: string, duration: number): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      position: 'bottom',
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            try {
              localStorage.setItem(DISMISS_KEY, '1');
            } catch {
              /* ignore */
            }
          },
        },
      ],
    });

    await toast.present();
  }
}
